// Small vanilla behaviors (no Stimulus/Turbo in this app).

function closeOpenDropdowns(except = null) {
	document.querySelectorAll("details[data-dropdown][open]").forEach((el) => {
		if (el !== except) el.removeAttribute("open");
	});
}

export function setupDropdowns() {
	document.addEventListener("click", (event) => {
		closeOpenDropdowns(event.target.closest("details[data-dropdown]"));
	});

	document.addEventListener("keydown", (event) => {
		if (event.key === "Escape") closeOpenDropdowns();
	});
}

// <form data-confirm="Are you sure?"> asks before submitting.
export function setupConfirmations() {
	document.addEventListener("submit", (event) => {
		const message = event.target.dataset?.confirm;
		if (message && !window.confirm(message)) event.preventDefault();
	});
}
